export const SET_USER_OLD_FORM = "SET_USER_OLD_FORM";

export const SET_RESUME_UPLOAD = "SET_RESUME_UPLOAD";

export const setUserOldForm = (response) => {
  return {
    type: SET_USER_OLD_FORM,
    payload: response,
  };
};

export const setResumeUpload = (response) => {
  return {
    type: SET_RESUME_UPLOAD,
    payload: response,
  };
};
